import React, { useEffect, useState } from 'react';
import { getPeakLevelData } from '../../../helper/PeakLevel/index';
import * as d3 from 'd3';
import TimeUtils from '../../../helper/TimeUtils';
//const UploadedFilesUrl = 'http://www.thesubpro.com/UploadedFiles/wave/';
const UploadedFilesUrl = 'http://104.237.55.12/UploadedFiles/wave/';

const WaveGroup = ({ _WaveformView }) => {
  const num = 5;

  const [drawn, setDrawn] = useState(false);
  const [orgFileName, setOrgFileName] = useState('');
  const [waveWidth, setWaveWidth] = useState(0);
  const [waveLeftPXArray, setWaveLeftPXArray] = useState([]);
  const [mySecondArray, setMySecondArray] = useState([]);

  useEffect(() => {
    console.log('I will only run if my deps change: ', num);

    // 安置圖片
    readTextFile();

    // download 聲紋資料
    // updatagetPeakLevelData();
  }, [num]);

  const updatagetPeakLevelData = async () => {
    if (drawn === true) {
      // 已繪製
      return;
    } else {
      setDrawn(true);

      const PeakData = await getPeakLevelData(
        'http://104.237.55.12/UploadedFiles/PeakLevel/HungrySoulsEP5withwatermark.log'
      );

      const data = PeakData[0];
      const chartData = PeakData[1];

      console.log('Peak 資料長度 ', data.length);
      // const data =

      //秒數
      const videoTotalSeconds = parseFloat(_WaveformView.video['seconds']);
      console.log('videoTotalSeconds ', videoTotalSeconds);

      //總長度 一秒 40 像素 1:01:32
      await setWaveWidth(videoTotalSeconds * 40);
      console.log('videoTotalSeconds ', videoTotalSeconds);
      console.log('videoTotalSeconds * 40 ', videoTotalSeconds * 40);
      const d3_waveWidth = videoTotalSeconds * 40;

      // set the dimensions and margins of the graph
      // Declare the chart dimensions and margins.
      const width = d3_waveWidth;
      const height = 100;
      const marginTop = 0;
      const marginRight = 0;
      const marginBottom = 0;
      const marginLeft = 0;

      const aapl = data;

      // Declare the x (horizontal position) scale.
      const x = d3.scaleUtc(
        d3.extent(aapl, (d) => d.x),
        [marginLeft, width - marginRight]
      );

      // Declare the y (vertical position) scale.
      // const y = d3.scaleLinear(
      //   [0, d3.max(aapl, (d) => d.y)],
      //   [height - marginBottom, marginTop]
      // );
      // 把最大值設定為100
      const y = d3.scaleLinear([0, 100], [height - marginBottom, marginTop]);

      // Declare the line generator.
      const line = d3
        .line()
        .x((d) => x(d.x))
        .y((d) => y(d.y));

      // Create the SVG container.
      const svg = d3
        .select('#my_dataviz')
        .append('svg')
        .attr('width', width)
        .attr('height', height)
        .attr('viewBox', [0, 0, width, height])
        .attr('style', 'max-width: 100%; height: auto; height: intrinsic;');

      // Add the x-axis.
      svg
        .append('g')
        .attr('transform', `translate(0,${height - marginBottom})`)
        .call(
          d3
            .axisBottom(x)
            .ticks(width / 80)
            .tickSizeOuter(0)
        );

      // Add the y-axis, remove the domain line, add grid lines and a label.
      svg
        .append('g')
        .attr('transform', `translate(${marginLeft},0)`)
        .call(d3.axisLeft(y).ticks(height / 40))
        .call((g) => g.select('.domain').remove())
        .call((g) =>
          g
            .selectAll('.tick line')
            .clone()
            .attr('x2', width - marginLeft - marginRight)
            .attr('stroke-opacity', 0.1)
        )
        .call((g) =>
          g
            .append('text')
            .attr('x', -marginLeft)
            .attr('y', 10)
            .attr('fill', 'currentColor')
            .attr('text-anchor', 'start')
            .text('')
        );

      // Append a path for the line.
      svg
        .append('path')
        .attr('fill', 'none')
        .attr('stroke', 'red')
        .attr('stroke-width', 2.5)
        .attr('d', line(aapl));
    }
  };

  const readTextFile = async () => {
    // DurationVal: "00:05:00.7600000                                            "
    // FrameRateVal: 24
    // HeightVal: 720
    // InputSizeVal: 10497112
    // NameVal: null
    // OutputSizeVal: null
    // SizeVal: null
    // StartTime: 0
    // WaveImage: "Indonesian_Test_File.png                                                                                                                                                                                                                                                                                                                                                                                        "
    // WidthVal: 1280
    // allDownloadUris: null
    // days: 7
    // downloadUris: null
    // fId: 421
    // fMeatdata: null
    // fProjectId: 0
    // fURL: "Indonesian_Test_File.mp4"
    // fVideoName: "Indonesian_Test_File.mp4"
    // hlsUri: null
    // inputAssetId: "                                                                                "
    // mpegDashUri: null
    // outputAssetId: null
    // seconds: 300.736
    // smoothStreamingUri: null
    //console.log(_WaveformView.video);

    if (_WaveformView.video['WaveImage'] === undefined) {
      return;
    }
    //檔案原始名稱
    const filename = _WaveformView.video['WaveImage']
      .split('.')
      .slice(0, -1)
      .join('.');
    await setOrgFileName(filename);
    console.log('檔案原始名稱 ', filename);

    //秒數
    let videoTotalSeconds = parseFloat(_WaveformView.video['seconds']);

    //分鐘次數
    const mp3Count = Math.ceil(videoTotalSeconds / 60); // 所要的音樂段數
    let _mySecondArray = [];
    let _myLeftArray = [];

    //總長度
    await setWaveWidth(videoTotalSeconds * 40);

    for (let i = 0; i < mp3Count; i++) {
      //取得音樂的開始與結束時間
      let start = 60 * i;
      let end = 0;
      if (start + 60 > videoTotalSeconds) {
        //是最後一段
        end = videoTotalSeconds;
      } else {
        //最後一段以前都是整數60
        end = start + 60;
      }

      const second = end - start;
      _mySecondArray.push(second);

      //左邊距離
      const waveLeftPX = start * 40 + 0;
      _myLeftArray.push(waveLeftPX);
    }
    setMySecondArray(_mySecondArray);
    setWaveLeftPXArray(_myLeftArray);
  };

  const result = [];
  let everysecond = 0;
  //秒數
  let videoTotalSeconds = parseFloat(_WaveformView.video['seconds']);
  while (videoTotalSeconds > 0) {
    const tCode = TimeUtils.convertSecondToTimeString(
      everysecond,
      _WaveformView.videoFps
    );

    // 一秒 40 像素
    const left = everysecond * 40 + 0;
    everysecond += 3;
    result.push(
      <div
        key={`wave_s_${videoTotalSeconds}`}
        style={{
          borderLeft: '2px solid rgb(158 158 158 / 34%)',
          position: 'absolute',
          top: '0px',
          left: `${left}px`,
          width: `100px`,
          height: '118px',
          paddingLeft: '2px',
        }}
      >
        {' '}
        {tCode}
      </div>
    );

    videoTotalSeconds = videoTotalSeconds - 2;
  }

  return (
    <div
      id={'WaveGroup'}
      style={{
        marginTop: '0px',
        position: 'relative',
        height: `96px`,
        width: `${waveWidth + 0}px`,
        // overflow: 'hidden',
      }}
    >
      {mySecondArray.map((e, index) => {
        const objLeftPX = waveLeftPXArray[index];
        return (
          <div
            key={`wave${index}`}
            style={{
              width: `${e * 40}px`,
              pointerEvents: 'none',
              position: 'absolute',
              top: '0px',
              left: `${objLeftPX}px`,
              height: '100px',
              overflow: 'hidden',
            }}
          >
            <img
              src={`${UploadedFilesUrl}${orgFileName}${index}.png`}
              style={{
                position: 'absolute',
                top: '-105px',
                left: `0px`,
                width: `${e * 40}px`,
                height: '400px',
              }}
            />
          </div>
        );
      })}

      <div
        id='SecondCode'
        style={{
          fontSize: '14px',
          position: 'absolute',
          top: '-20px',
          height: `100px`,
          left: '0px',
          width: `${waveWidth}px`,
          overflow: 'show',
        }}
      >
        <div
          style={{
            marginTop: '0px',
            position: 'relative',
            height: `96px`,
          }}
        >
          {/* 依照總秒數 videoTotalSeconds  分出3 秒間隔 */}

          {result}
        </div>
      </div>
      {/*<img src={`http://subprpapp.azurewebsites.net/UploadedFiles/${this.props.video['WaveImage']}`}　style={{*/}
      {/*    width:`${waveWidth+300}px`,*/}
      {/*    pointerEvents:'none',*/}
      {/*    position: 'absolute',*/}
      {/*    top: '-20px',*/}
      {/*    left:'300px' ,height:'232px'}} />*/}
    </div>
  );
};

export default WaveGroup;



// WEBPACK FOOTER //
// ./src/components/drogable/wave/WaveGroup.js